import React from 'react';

import { Alert } from '@mui/material';

export default function ReviewSnapshotNotice() {
  return (
    <Alert severity="info" sx={{ my: 1 }}>
      RM review statuses appear after the next morning refresh.
    </Alert>
  );
}
